import { getConversationAudioBlob } from '../api/conversations';

/** Файл разговора — один раз в память, дальше играем и режем его оттуда.
 *
 *  Плеер по прямой ссылке на хранилище зависал намертво (владелец, 16.09): в
 *  Network отменённый запрос к conv_NNNNN.ogg и тот же запрос много раз. У ogg нет
 *  индекса для перемотки, и браузер ищет место кусками (range-запросами к той же
 *  ссылке), отменяя прошлые на каждом переходе; зависни один такой запрос —
 *  элемент не оживает. Файл разговора маленький (3.8 мин ≈ 570 КБ), поэтому
 *  качаем его целиком через API (у бакета нет CORS) и отдаём элементу blob:-ссылку —
 *  перемотка больше не ходит в сеть. Те же байты берёт точное проигрывание
 *  фразы, второй раз не качаем.
 *
 *  Кэш на страницу: последние несколько разговоров, старые ссылки освобождаются. */
type Entry = { promise: Promise<{ blob: Blob; url: string }>; url?: string };

const MAX = 8;
const cache = new Map<number, Entry>();

export function loadConversationAudio(id: number): Promise<{ blob: Blob; url: string }> {
  const hit = cache.get(id);
  if (hit) {
    cache.delete(id);
    cache.set(id, hit);
    return hit.promise;
  }
  const entry: Entry = {
    promise: getConversationAudioBlob(id)
      .catch(() => getConversationAudioBlob(id))
      .then((blob) => {
        const url = URL.createObjectURL(blob);
        entry.url = url;
        return { blob, url };
      }),
  };
  // Не удалось скачать — не держим провал в кэше: следующий раскрывший попробует снова.
  entry.promise.catch(() => { if (cache.get(id) === entry) cache.delete(id); });
  cache.set(id, entry);
  while (cache.size > MAX) {
    const [oldId, old] = cache.entries().next().value as [number, Entry];
    cache.delete(oldId);
    if (old.url) URL.revokeObjectURL(old.url);
  }
  return entry.promise;
}
